import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { Course } from '@shared/models/course.model';
import { AuthenticationService } from '@shared/services/authentication.service';
import { environment } from '@env/environment';
import { AddParticipantDialogComponent } from '@shared/components/add-participant-dialog/add-participant-dialog.component';
import { LinkService } from '@shared/services/link.service';
import {CourseRelease, HubMode, LearnspaceMode} from '@shared/models';
import {CurrentHubService} from '@shared/services/currentHub.service';
@Component({
  selector: './embed-dialog.component',
  templateUrl: './embed-dialog.component.html',
  styleUrls: ['./embed-dialog.component.scss']
})
export class EmbedDialogComponent implements OnInit {
  embedcode = '';
  learnerLink = '';
  presenterLink = '';
  course: Course;
  status: string;
  experienceIsMulti: boolean;
  presenterShortCode = '';
  learnerShortCode = '';
  shortCodeDomain = '';
  presenterTooltipMessage = '';
  learnerTooltipMessage = '';
  courseLatestRelease: CourseRelease;
  hubMode: HubMode;

  _hasPublished = false;
  _hasPublishedAndReset = false;
  _hasSuccessfullyPublished = false;

  constructor(
    private _dialog: MatDialog,
    private _courseApiService: CoursesAPIService,
    private _hubService: CurrentHubService,
    private _authService: AuthenticationService,
    private dialogRef: MatDialogRef<EmbedDialogComponent>,
    private _linkService: LinkService,
    @Inject(MAT_DIALOG_DATA) public data: { course: Course, styleClass: string }
  ) {
   }
  ngOnInit(): void {
    this.course = this.data.course;
    this.status = this.course.public_status;
    this.hubMode = this._hubService.getHubMode();

    // Short code
    this._courseApiService.getCourseLinks(this.course.id).subscribe(links => {
      this.shortCodeDomain = links.domain;
      this.presenterShortCode = this.addDash(links.presenterCode, 3);
      this.learnerShortCode = this.addDash(links.learnerCode, 3);

      this.presenterTooltipMessage = `On your device's web browser, go to ${this.shortCodeDomain} and enter ${this.presenterShortCode}`
      this.learnerTooltipMessage = `On your device's web browser, go to ${this.shortCodeDomain} and enter ${this.learnerShortCode}`

      this.presenterLink = links.presenterLink;
      this.learnerLink = links.learnerLink;
      this.embedcode = `<iframe allowfullscreen="yes" allowvr ="yes" allow="autoplay ${window.location.origin}; microphone ${window.location.origin}" frameborder="0" height="550px" scrolling="no" width="100%" src="${this.presenterLink}"></iframe>`;
    });

    this._courseApiService.getLatestCourseRelease(this.course.id).subscribe( courseRelease => {
      this.courseLatestRelease = courseRelease;
    }, error => {
      this.courseLatestRelease = null;
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSharingChange($event: any): void {
    this.status = $event.value;
    this._courseApiService.updateCourse(this.course.id, { public_status: this.status }).subscribe(course => {
      this.course = course;
    });
  }

  onVersioningChange($event: any): void {
    const isVersioningEnabled = $event.checked;
    this._courseApiService.updateCourse(this.course.id, { information: {...this.course.information, versioningEnabled: isVersioningEnabled}}).subscribe(course => {
      this.course = course;
    });
  }

  isVersioningAvailable(): boolean {
    return this._hubService.isPaid() && !this.course.is_multi;
  }

  getVersioningTooltipMessage(): string {
    if (this.isVersioningAvailable()) {
      return '';
    } else if (this._hubService.isFree()) {
      return 'Upgrade to access this feature';
    } else {
      return 'Switch to single player to enable versioning';
    }
  }

  canPublish(): boolean {
    return !this._hasPublishedAndReset && !this._hasPublished;
  }

  canPublishAndReset(): boolean {
    return !this._hasPublishedAndReset;
  }

  onPublish(): void {
    let newVersion;
    if (this.courseLatestRelease) {
      newVersion = CourseRelease.IncrementVersion(this.courseLatestRelease.version, false);
    } else {
      newVersion = '1.0';
      this._hasPublishedAndReset = true;
    }
    this._hasPublished = true;
    this._courseApiService.releaseCourse(this.course.id, newVersion).subscribe((courseRelease) => {
      this._hasSuccessfullyPublished = true;
      this.courseLatestRelease = courseRelease;
    });
  }

  onPublishAndReset(): void {
    let newVersion;
    if (this.courseLatestRelease) {
      newVersion = CourseRelease.IncrementVersion(this.courseLatestRelease.version, true);
      this._hasPublishedAndReset = true;
    } else {
      return;
    }
    this._courseApiService.releaseCourse(this.course.id, newVersion).subscribe((courseRelease) => {
      this.courseLatestRelease = courseRelease;
    });
  }
  launchInNewTab(url: string): void {
    window.open(url);
  }
  copy(event: any): void {
    // The text we want to highlight is previous textarea or input element
    const urlContainer = event.target.parentElement;
    const associatedText = urlContainer.querySelector('input, textarea');
    if (associatedText){
      associatedText.select();
      document.execCommand('copy');
    }
  }
  addDash(code: string, pos: number): string{
    if(pos > code.length){
      return code;
    }
    return `${code.slice(0, pos)}-${code.slice(pos, code.length)}`;
  }
  blockEventAndOpenVersioningHelp(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.openVersioningHelp();
  }
  openSharingHelp(): void{
    window.open('https://help.spaces.wondavr.com/en/articles/2491541-sharing-options');
  }
  openRolesHelp(): void{
    window.open('https://help.spaces.wondavr.com/en/articles/2491549-setup-a-multiplayer-session#h_d515f94ce7');
  }
  openVersioningHelp(): void {
    window.open('https://help.spaces.wondavr.com/en/articles/6803375-how-to-handle-versioning');
  }
}
